module.exports = __webpack_public_path__ + "static/media/Ethereum.5bd4d074.svg";